module.exports = __webpack_public_path__ + "static/Bosk.ttf-7ad2fe085d2c73488d87091636e12c8e.svg";